export const UrlParams = {
  EVENT_ID: 'eventId',
  THEME: 'theme',
  DEFAULT_STATS_CONSOLE_TAB: 'defSCTab',
  INITIAL_TAB: 'initialTab',
  FIXTURES: 'fixtures',
  IS_MVP: 'isMVP',
  FIXED_HEIGHT: 'fixedHeight',
  LANG_MONITORING: 'langMonit',
  DYNAMIC_COLORS: 'isDynamicColors',
  VERSION: 'version',
  IOS: 'ios',
  PLATFORM: 'platform',
  IS_GROUP_TABLE_VISIBLE: 'isGroupTableVisible',
} as const;

export type UrlParams = (typeof UrlParams)[keyof typeof UrlParams];
